import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    container: `
      w-full
      bg-white
    `,
    header: '',
    promotionalPrice: 'line-through',
    strip: 'p-2',
  },
  compoundVariants: [
    {
      isOffer: true,
      isOutlet: false,
      className: {
        strip: 'bg-critical-600',
      },
    },
    {
      isOffer: true,
      isOutlet: true,
      className: {
        strip: 'bg-green-700',
        header: `
          bg-black
          px-2
          pb-2
          pt-1
        `,
      },
    },
  ],
  variants: {
    isOutlet: {
      true: '',
    },
    isOffer: {
      false: {
        container: `
          border-t-4
          border-green-700
        `,
      },
    },
  },
});
